import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { EditIcon, CloseIcon } from './../../../themes/icons';
import { Loading } from './../../../components/includes/loading';
import { Section, Content, Main, Buttons } from './../../../components/includes/container';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Table, Thead, Tbody, Row, Cell, Tresponsive, Ttolbar } from './../../../components/includes/ui/table';
import { Btn, Label } from './../../../components/includes/ui';
import { FormatDate } from './../../../utilities/date';
import { isUndefined, isSorting, isStatus } from './../../../utilities/utils';
import { AlertService } from './../../../services';
import Confirm from './../../shared/confirm';

const rows = [
  { id: 'name', sort: false, numeric: false, disablePadding: false, label: 'Nombre' },
  { id: 'description', sort: false, numeric: false, disablePadding: false, label: 'Descripción' },
  { id: 'type', sort: false, numeric: false, disablePadding: false, label: 'Tipo' },
  { id: 'status', sort: false, numeric: false, disablePadding: false, label: 'Estado' },
  { id: 'created_at', sort: false, numeric: false, disablePadding: false, label: 'Creado' },
  { id: 'updated_at', sort: false, numeric: false, disablePadding: false, label: 'Editado' },
  { id: 'actions', sort: false, numeric: true, disablePadding: false, label: 'Acciones', width:120, minWidth: 120 }
];

class Alerts extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      loading: false,
      page: 0,
      order: 'asc',
      orderBy: 'name',
      entities: null,
      formDeleteShow: false,
      formDeleteMessage: null
    };
  }

  componentDidMount(){

    // @Pagination
    let page = this.props.match.params.page;

    if(!isUndefined(page)){

      if(!isNaN(page) && page >= 0){

        this._Find(page);

      }else{

        this.props.history.push('/alerts');

      }

    }else{

      this._Find(this.state.page);

    }

  }

  /*
  ** @Service
  ** @Description: FindAll
  */

  _Find = (page) => {

    AlertService.get(page).then((response) => {

      this.setState({ loading: true, page: !isUndefined(page) ? parseInt(page,10) : 0, entities: response });

    }).catch((error) => {

      this.props.AlertShow({ open: true, variant: 'error', message: Error.internal });

    });

  }

  /*
  ** @Service
  ** @Description: Delete
  */

  _Delete = (id) => {

    AlertService.remove(id).then((response) => {

      // @State
      this.setState({ formDeleteShow: false });

      // @Service find all by page
      this._Find(this.props.match.params.page);

      // @Dispatch alert success
      this.props.AlertShow({ open: true, variant: 'success', message: `Exito, el alerta fue eliminado.` });

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: Error.internal });

    });

  }

  /*
  ** @Event
  ** @Description: Delete user
  */

  handleDelete = (id, name) => {
    this.setState({
      id: id,
      formDeleteShow: true,
      formDeleteMessage: `¿Confirma la eliminación de ${ name }?`
    });
  }

  /*
  ** @Click
  ** @Description: Delete user
  */

  handleConfirmDeleteConfirm = () => {
    this._Delete(this.state.id);
  }

  /*
  ** @Click
  ** @Description: Cancel delete user
  */

  handleConfirmDeleteCancel = () => {
    this.setState({ formDeleteShow: false });
  }

  render() {

    const { loading, order, orderBy, entities } = this.state;

    return (
      <Section>

        <ToolbarPrimary title="Alertas"/>
        <BreadcrumbItem to='/alerts'>Alertas</BreadcrumbItem>

        <Content>
          <Main>

            <Confirm
               status={ this.state.formDeleteShow }
               message={ this.state.formDeleteMessage }
               cancel={ () => { this.handleConfirmDeleteCancel() } }
               confirm={ () => { this.handleConfirmDeleteConfirm() } }
            />

            <Ttolbar title="Alertas">
              <Buttons>
                <Btn color="success" aria-label="add" icon="add" component={ NavLink } to="/alerts/create">
                  Crear alerta
                </Btn>
              </Buttons>
            </Ttolbar>

            { loading ? (
              <Tresponsive>
                <Table>

                  <Thead rows={ rows } order={ order } orderBy={ orderBy } onRequestSort={ this.handleRequestSort }/>

                  <Tbody>

                    { entities.alerts.length > 0 ? (

                      entities.alerts.sort(isSorting(order, orderBy)).map(entity => {
                        return (
                          <Row key={ entity._id }>
                            <Cell>{ entity.name }</Cell>
                            <Cell>
                              <span dangerouslySetInnerHTML={{ __html: entity.description }}/>
                            </Cell>
                            <Cell>
                              <Label variant="info">
                                { entity.type }
                              </Label>
                            </Cell>
                            <Cell>
                              <Label variant={ entity.status ? "success" : "danger"}>
                                { isStatus(entity.status) }
                              </Label>
                            </Cell>
                            <Cell>
                              <FormatDate value={ entity.created_at }/>
                            </Cell>
                            <Cell>
                              <FormatDate value={ entity.updated_at }/>
                            </Cell>
                            <Cell numeric>
                              <Btn color="danger" size="xsmall" onClick={ () => { this.handleDelete(entity._id, `${ entity.name }`) } }>
                                <CloseIcon fontSize="small"/>
                              </Btn>
                              <Btn color="primary" size="xsmall" component={ NavLink } to={ `/alerts/update/${ entity._id }` }>
                                <EditIcon fontSize="small"/>
                              </Btn>
                            </Cell>
                          </Row>
                        );
                      })

                    ) : (

                      <Row key="1">
                        <Cell colSpan={ rows.length }>No se encontraron resultados.</Cell>
                      </Row>

                    )}

                  </Tbody>

                </Table>
              </Tresponsive>
            ) : (
              <Loading variant="primary"/>
            ) }

          </Main>
        </Content>
      </Section>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Alerts);
